import type { Ref } from "vue";
import { ref } from "vue";
import type { AxiosError } from "axios";

interface PayloadWithFile {
  file: File;
  [key: string]: any; // Allows additional properties for the provided callback
}

type ImportPayload = File | PayloadWithFile | null;

export function useImportCsvModal() {
  const file: Ref<File | null> = ref(null);
  const csvLoaded = ref(false);
  const csvLoading = ref(false);
  const csvLoadError = ref(false);
  const invalidRecords = ref(0);
  const successfullyUploaded = ref(0);
  const errorMessage = ref<string | undefined>("");

  const handleFileUpload = (uploadedFile: File) => {
    file.value = uploadedFile;
  };

  const handleImport = async (payload: ImportPayload = file.value, callback: Function) => {
    if (!file.value) return;

    csvLoaded.value = false;
    csvLoading.value = true;

    try {
      const response = await callback(payload);
      csvLoaded.value = true;
      csvLoading.value = false;
      csvLoadError.value = false;
      invalidRecords.value = response?.data?.invalidRecords;
      successfullyUploaded.value = response?.data?.successfullyUploaded || response.processed;
    } catch (e) {
      const error = e as AxiosError<{ errors: [string] }>;
      console.error(e);
      csvLoaded.value = true;
      csvLoading.value = false;
      csvLoadError.value = true;
      errorMessage.value = error.response?.data?.errors?.[0];
    }
  };

  return {
    file,
    csvLoaded,
    csvLoading,
    csvLoadError,
    invalidRecords,
    successfullyUploaded,
    errorMessage,
    handleFileUpload,
    handleImport,
  };
}
